import React, { useState } from 'react';
import mixpanel from 'mixpanel-browser';
import { useDispatch } from 'react-redux';

import { DirectionsCar as DirectionsCarIcon, Home as HomeIcon } from '@mui/icons-material';
import { Button } from '@mui/material';

import { Loader } from '../../Elements/Loader';
import { ModalPopup } from '../../Elements/Modal';

import { EmailRates } from '../EmailRates';

import { clearSignUpUserErrorMessage } from '../../../actions/usersActions';

import {
  SEARCH_RESULTS_FOR,
  AUTO,
  HOME,
  EMAIL_RATES,
  EMAIL_AUTO_RATES_TO_YOURSELF,
} from '../../../constants/ComparisonSummary';

import './SearchResultsFor.css';

export const getIcon = (financingType) => {
  const ICONS = {
    [AUTO]: <DirectionsCarIcon />,
    [HOME]: <HomeIcon />,
  };

  return ICONS[financingType];
};

export const SearchResultsFor = ({
  financingType = AUTO,
  isLoading = false,
  isOnCalculatorPage,
  handleEmailRates,
  setIsEmailRatesSubmitted,
  isEmailRatesSubmitted,
  signUpError,
  user,
}) => {
  const [isOpenEmailModal, setIsOpenEmailModal] = useState(false);
  const dispatch = useDispatch();
  const financeTypeText = isOnCalculatorPage ? (
    <div className="finance-calculator-type-text">{financingType}</div>
  ) : (
    <div className="finance-type-text">{financingType}</div>
  );

  const handleOpenModal = () => {
    setIsOpenEmailModal(true);

    mixpanel.track(`Email Rates ${financingType}`, {
      financingType,
      action: 'OPEN EMAIL RATES MODAL',
      isSignedUser: user?.id,
    });
  };

  return (
    <div className="search-results-for-email-rate-button-wrapper">
      <div className="search-results-for-wrapper">
        <div className="search-results-for">{SEARCH_RESULTS_FOR}</div>
        <div className="finance-type-wrapper">
          {isLoading ? (
            <Loader size={25} />
          ) : (
            <>
              {getIcon(financingType)}
              {financeTypeText}{' '}
            </>
          )}
        </div>
      </div>
      {typeof setIsEmailRatesSubmitted === 'function' && (
        <div className="email-rates-modal-popup-wrapper">
          <ModalPopup
            buttonContent={
              <Button
                variant="contained"
                disableRipple
                sx={{
                  '&:hover': { boxShadow: 'none', textDecoration: 'none' },
                  '&:active': { boxShadow: 'none' },
                  borderRadius: '10px',
                  backgroundColor: 'black',
                  textTransform: 'none',
                  pl: { xs: 0.5, md: 1.25 },
                  pr: { xs: 0.5, md: 1.25 },
                  minWidth: { xs: '58px', sm: '64px' },
                  height: '100%',
                  fontSize: { xs: '12px', md: '14px' },
                  lineHeight: 1.5,
                }}
                onClick={handleOpenModal}
              >
                {EMAIL_RATES}
              </Button>
            }
            modalContent={
              <EmailRates
                userId={user?.id}
                user={user}
                handleEmailRates={handleEmailRates}
                isEmailRatesSubmitted={isEmailRatesSubmitted}
                signUpError={signUpError}
              />
            }
            title={EMAIL_AUTO_RATES_TO_YOURSELF}
            modalButtonId="email-rates-modal-button"
            handleOpen={() => {}}
            handleClose={() => {
              setIsOpenEmailModal(false);
              setIsEmailRatesSubmitted(false);
              dispatch(clearSignUpUserErrorMessage);
              mixpanel.track(`Email Rates ${financingType}`, {
                financingType,
                action: 'CLOSE EMAIL RATES MODAL',
                isSignedUser: user?.id,
              });
            }}
            open={isOpenEmailModal}
          />
          {/* <Button variant="contained" sx={{ }}>Print Rates</Button> */}
        </div>
      )}
    </div>
  );
};
